module.exports = __webpack_public_path__ + "img/1.437d9d4c.jpg";